
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"16","viewBox":"0 0 24 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M18.195 6.54l1.748.188c.42.046.826.16 1.207.342l1.455.694.201-.423-1.454-.694a4.212 4.212 0 00-1.36-.385l-2.032-.22-.448-.95c.2-.387.15-1.547-.15-1.547a.59.59 0 00-.463.247l-.807-1.712-.899-.232a.352.352 0 10-.177.681l.58.151.335.709-1.537 1.464-2.392.484-.06-.005-3.527-.282-4.456-.357a1.491 1.491 0 00-1.14.408L1 6.838l.323.34 1.82-1.739c.21-.199.494-.3.78-.28l2.095.168.192.016.253.702c.171.474.495.878.92 1.148l1.192.758 1.604 1.02.041.026.098.172-4.443 1.624a.352.352 0 00.24.66l4.556-1.665.117.207.29.512 2.296.351c.374.058.749-.094.978-.393l1.868-2.433h-2.344v-.179h2.353v-.276h-3.32V7.4h3.415l1.302-.411 1.112 2.354.909 1.93a.351.351 0 10.636-.3v.001l-.904-1.919-1.184-2.514zM5.238 5.835l.99.076.07.194c.116.319.297.61.528.855l-1.663-.127.016-.211-.37-.028.044-.576.37.028.015-.21zm13.981 2.39a3.018 3.018 0 11-.982.459l.488 1.046a1.891 1.891 0 001.257 3.309c1.044 0 1.894-.85 1.894-1.894a1.896 1.896 0 00-2.169-1.873l-.488-1.047zM8.986 11.36a3.03 3.03 0 00-.043-.768l-1.08.412a1.896 1.896 0 01-2.024 2.029 1.896 1.896 0 01-1.752-2.024 1.89 1.89 0 013.39-1.017l1.079-.412a3.018 3.018 0 10.43 1.78z","fill":"currentColor"}})])
          )
        }
      }
    